export default "__VITE_ASSET__C1LyQ22m__"